<template>
  <div class="container">
    <div class="row">
      <NavButton
        v-if="showButtons"
        :properties="BackBtn"
        @mouseup="pageBack()"
      />
      <NavButton v-if="showButtons" :properties="HomeButton" />

      <button
        id="look-product"
        class="btn btn-red ms-1"
        type="button "
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasWithBackdrop"
        aria-controls="offcanvasWithBackdrop"
        @mouseup="getCart()"
      >
        Bekijk uw producten
      </button>
    </div>

    <div
      class="offcanvas offcanvas-start"
      tabindex="-1"
      id="offcanvasWithBackdrop"
      aria-labelledby="offcanvasWithBackdropLabel"
    >
      <div class="offcanvas-header">
        <h5
          class="offcanvas-title selection-product"
          id="offcanvasWithBackdropLabel"
        >
          Uw gekozen producten
        </h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <table class="w-100 table-light">
          <tr class="test">
            <th class="col-2 text-start" id="image">Afbeelding</th>
            <th class="col-2 text-start" id="name">Naam</th>
            <th class="col-2 text-start color">Kleur</th>
            <th class="col-2 text-center number">Aantal</th>
            <th class="col-3 text-center" id="select-rols">
              Geselecteerde rolbreedte
            </th>
          </tr>
          <template v-if="cart.length > 0">
            <tr
              v-for="(product, index) in cart"
              :key="product.index"
              class="rowCart h-50 w-100"
            >
              <td class="p-0 m-0">
                <img
                  class="rowCart no-select"
                  :src="$Functions.getImage(product.afbeelding)"
                />
              </td>
              <td class="p-0 m-0">
                <p
                  class="p-0 m-0 text-start naamNote"
                  v-show="!product.naam == ''"
                >
                  {{ product.naam }}
                </p>
              </td>
              <td class="p-0 m-0">
                <p
                  class="p-0 m-0 text-start kleurNote"
                  v-show="!product.kleur == ''"
                >
                  {{ product.kleur }}
                </p>
              </td>
              <td
                class="p-0 m-0 d-flex flex-row align-content-center aantalNote flex-nowrap"
              >
                <button
                  @mouseup="decrease(index)"
                  class="col-1 buttonKleurProduct w-25 h-25 ms-2 me-3 fs-3"
                >
                  -
                </button>
                <p
                  class="col-9 p-0 m-0 w-25 text-center btn-group-vertical"
                  v-show="!product.amount == ''"
                >
                  {{ product.amount }}
                </p>
                <button
                  @mouseup="add(index)"
                  class="col-1 buttonKleurProduct w-25 h-25 me-3 fs-3"
                >
                  +
                </button>
              </td>

              <td class="p-0 m-0">
                <p
                  class="p-0 m-0 text-center breedteNote"
                  v-if="!product.selectedRol == ''"
                >
                  {{ product.selectedRol }} {{ product.rolBreedteEenheid }}
                </p>
                <p class="p-0 m-0 text-center breedteNote" v-else>n.v.t.</p>
              </td>
              <td class="p-0 m-0 devideMobile">
                <i
                  @mouseup="remove(index)"
                  class="fas fa-times text-danger text-end"
                ></i>
              </td>
            </tr>
          </template>
        </table>
      </div>

      <div class="offcanvas-footer">
        <div class="row justify-content-between m-2">
          <NavButton v-if="showButtons" :properties="newProductBtn" />
          <NavButton v-if="this.cartqty > 0" :properties="ApplicationBtn" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavButton from "@/components/NavButton.vue";

export default {
  components: {
    NavButton,
  },
  data() {
    return {
      active: false,
      cartqty: 0,
      cart: [],
      HomeButton: {
        routeName: this.$RouteNames.assortment,
        class:
          "btn btn-grey text-uppercase p-1 text-center link-assortiments ms-1",
        id: "",
        label: "Terug naar overzicht",
        type: "btn",
        function: undefined,
      },
      ApplicationBtn: {
        routeName: this.$RouteNames.application,
        class:
          "btn btn-grey text-uppercase p-1 text-center link-assortiments ms-1",
        id: "quotation",
        label: "Offerte afronden",
        type: "btn",
        function: undefined,
      },
      newProductBtn: {
        routeName: this.$RouteNames.assortment,
        class:
          "btn add-product terug-knop bg-gray text-uppercase col-5 router-button addProductButton fontSizeButton",
        id: "",
        label: "Nieuw product toevoegen",
        type: "btn",
        function: undefined,
      },
      BackBtn: {
        routeName: "",
        class: "back-btn btn btn-grey p-3",
        id: "",
        type: "btn",
        function: undefined,
      },
    };
  },
  created() {
    this.getCart();
  },
  beforeUpdate() {
    this.getCart();
  },
  methods: {
    getCart() {
      this.cart = this.$store.getters.getCART;
      this.cartqty = this.cart.length;
    },
    modalToggle() {
      const body = document.querySelector("body");
      this.active = !this.active;
      this.active
        ? body.classList.add("modal-open")
        : body.classList.remove("modal-open");
    },
    decrease(index) {
      if (this.cart[index].amount > 1) {
        this.cart[index].amount--;
        this.$store.commit("contentCART", {
          key: "amount",
          value: this.cart[index].amount,
        });
      } else {
        this.$store.commit("removeItemCART", index);
      }
    },
    remove(index) {
      this.$store.commit("removeItemCART", index);
    },
    add(index) {
      this.cart[index].amount++;

      this.$store.commit("contentCART", {
        key: "amount",
        value: this.cart[index].amount,
      });
    },
    pageBack() {
      const selection = this.$Functions.getSelection(this.$route.name);

      const routes = this.$router.options.routes;

      let routeName = `${selection.lang}-${this.$RouteNames.assortment}`;

      if (selection.code.length === 6) {
        routeName = `${selection.lang}-${selection.assortmentCode}`;
      } else if (
        selection.code.length > 6 &&
        this.$route.name !== `${selection.lang}-${this.$RouteNames.application}`
      ) {
        routeName = `${selection.lang}-${selection.assortmentCode}${selection.collectionCode}`;
      } else if (
        this.$route.name === `${selection.lang}-${this.$RouteNames.application}`
      ) {
        for (let index in routes) {
          if (routes[index].path === this.$router.options.history.state.back) {
            routeName = `${selection.lang}-${
              this.$Functions.getSelection(routes[index].name).code
            }`;
            break;
          }
        }
      }
      this.$router.push({ name: routeName });
    },
  },
  computed: {
    showButtons() {
      const routePath = this.$route.path;

      // Get language
      let langArray = "";
      let langMain = "";

      if (this.$store.getters.getLang.includes("-")) {
        langArray = this.$store.getters.getLang.split("-");
        langMain = langArray[0].toLowerCase();
      } else {
        langMain = this.$store.getters.getLang.toLowerCase();
      }

      if (routePath === "/" || routePath === "/" + langMain) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {},
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: #fff;
}
.addProductButton {
  background-color: var(--Grijs);
  color: var(--Wit);
  font-weight: 400;
  font-size: 1rem;
}
.buttonKleurProduct {
  background-color: var(--Wit);
  color: var(--BlauwGrijs);
}
.addProductButton:hover,
.buttonKleurProduct:hover {
  background-color: #fff;
  border: 1px solid #c8191b !important;
  color: #c8191b;
  border: none;
  color: var(--Rood);
}

.btn-close:hover {
  background-color: #fff;
  border: 1px solid #c8191b !important;
  color: #c8191b !important;
}

.rowCart {
  height: 50px;
  width: 50px;
  margin-bottom: 10px;
  border-radius: 10% !important;
  text-align: center;
}

.modal-dialog {
  max-width: 900px !important;
}

.offcanvas-start {
  width: 750px;
}

.no-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

@media screen and (max-width: 600px) {
  a {
    font-size: 12px;
  }
  tr,
  td {
    display: flex;
    flex-wrap: wrap;
  }
  .test {
    display: none;
  }
  .breedteNote:before {
    content: "Breedte: ";
  }
  .aantalNote:before {
    content: "Aantal: ";
  }
  .naamNote:before {
    content: "Naam: ";
  }
  .kleurNote:before {
    content: "Kleur: ";
  }
  .rowCart {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 50px;
    margin-bottom: 10px;
    width: 25%;
  }
  .h-25 {
    height: initial !important;
  }
  .devideMobile {
    border-bottom: 1px solid gray;
  }
}
</style>
